import { render, staticRenderFns } from "./RecommendUser.vue?vue&type=template&id=665d3ba0&"
import script from "./RecommendUser.vue?vue&type=script&lang=js&"
export * from "./RecommendUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports